import Lottie from "react-lottie";
import { assets } from "../../assets";
import { colors } from "../ui/colors";

export const LoadingCard = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: assets.animation.flownectLogo,
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <Lottie options={defaultOptions} width={280} height={280} />
    </div>
  );
};